import React, { Component } from "react";
import Moment from "moment";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Modal,
  Label,
  ModalHeader,
  ModalBody,
  Spinner,
  FormGroup,
  Input,
} from "reactstrap";
import { validateToken, has_Permission } from "../../helpers/jwt-token-access/accessToken";
import { AvForm, AvField } from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { BaseUrl } from "../../helpers/Baseurl";
import { getDifferenceInDays, createSlugfromName } from "../../helpers/methods";
import { Link } from "react-router-dom";
import { get } from "../../helpers/api_helper";
import { isEmpty } from "lodash";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

class DailyPlan extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"));
    if (!this.obj) {
      this.props.history.push("/logout");
    } else if (!validateToken(this.obj.access)) {
      this.props.history.push("/logout");
    }
    this.state = {
      selected_plan: null,
      edit_selected_plan: null,
      selected_id: "",
      day: 0,
      Payemnts: [],
      selectedVisitingPlaces: [],
      selectedCurrentLocations: { label: "Select Current Location", value: "" },
      selectedTravelLocation: { label: "Not Travelling", value: "" },
      Activities: [],
      selectedActivities: [],
      Hotels: [],
      selectedHotels: [],
      Vehicles: [],
      selectedVehicles: [],
      selected_id: {
        comment: "",
      },
      comment: "",
    };

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "false",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000,
    };

    this.handleSaveTimePlan = this.handleSaveTimePlan.bind(this);
    this.handleAddNewRowData = this.handleAddNewRowData.bind(this);
    this.handleEditRowData = this.handleEditRowData.bind(this);
    this.tog_addData = this.tog_addData.bind(this);
    this.tog_EditData = this.tog_EditData.bind(this);
    this.clearData = this.clearData.bind(this);
    this.tog_center = this.tog_center.bind(this);
    this.tog_time_plan = this.tog_time_plan.bind(this);
    this.tog_time_plan_detail = this.tog_time_plan_detail.bind(this);
    this.handleDeleteTimePlan = this.handleDeleteTimePlan.bind(this);
  }

  tog_addData() {
    this.setState((prevState) => ({
      model_AddData: !prevState.model_AddData,
    }));
    this.removeBodyCss();
  }

  tog_EditData() {
    this.setState((prevState) => ({
      model_EditData: !prevState.model_EditData,
    }));
    this.removeBodyCss();
  }

  tog_center() {
    this.setState((prevState) => ({
      modal_center: !prevState.modal_center,
    }));
    this.removeBodyCss();
  }

  tog_time_plan() {
    this.setState((prevState) => ({
      modal_time_plan: !prevState.modal_time_plan,
    }));
    this.removeBodyCss();
  }

  tog_time_plan_detail() {
    this.setState((prevState) => ({
      modal_time_plan_detail: !prevState.modal_time_plan_detail,
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidMount = async () => {
    document.title = "Itinerary Daily Plan | Planmans";
    await this.loadItineraryVehicles(); // Load vehicles first
    await this.loadDailyPlanData();    // Then load daily plans
    this.loadItineraryData();
    this.loadItineraryActivities();
    this.loadItineraryHotels();
  };

  clearData() {
    let selected_id = "";
    let selectedVisitingPlaces = [];
    let selectedCurrentLocations = { label: "Select Current Location", value: "" };
    let selectedTravelLocation = { label: "Not Travelling", value: "" };
    let selectedHotels = [];
    let selectedVehicles = [];
    let selectedActivities = [];

    this.setState({
      selected_id,
      selectedVisitingPlaces,
      selectedCurrentLocations,
      selectedTravelLocation,
      selectedHotels,
      selectedVehicles,
      selectedActivities,
      date: false,
      comment: "",
    });
  }

  async loadItineraryData() {
    let id = this.props.match.params.id;
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itineraries/${id}/`, requestOptions)
      .then((res) => res.json())
      .then(
        (data) => {
          let date_diff = getDifferenceInDays(new Date(data.end_date), new Date(data.start_date));
          let destinations = data.destinations;

          let options = [{ label: data.pick_up_location.name, value: data.pick_up_location.id }];
          if (data.pick_up_location.id !== data.drop_off_location.id) {
            options.push({ label: data.drop_off_location.name, value: data.drop_off_location.id });
          }

          for (let i = 0; i < destinations.length; i++) {
            if (![data.pick_up_location.id, data.drop_off_location.id].includes(destinations[i].id)) {
              options.push({ label: destinations[i].name, value: destinations[i].id });
            }
          }
          let places = options;
          for (let i = 0; i < data.places.length; i++) {
            places.push({ label: data.places[i].name, value: data.places[i].id });
          }
          let VisitingPlaces = [
            {
              label: "Places",
              options: places,
            },
          ];
          let ToTravelLocations = [
            {
              label: "Location",
              options: [{ label: "Not Travelling", value: "" }, ...places],
            },
          ];
          this.setState({ itinerary: data, days: date_diff, VisitingPlaces, ToTravelLocations });
        },
        (error) => {
          console.log(error, "error--------------");
        }
      );
  }

  async loadDailyPlanData() {
    let id = this.props.match.params.id;
    const requestOptions = {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
    };
  
    try {
      // Ensure itineraryVehicles is loaded first
      if (!this.state.itineraryVehicles || this.state.itineraryVehicles.length === 0) {
        console.log("itineraryVehicles not loaded yet, fetching...");
        await this.loadItineraryVehicles();
      }
      console.log("itineraryVehicles:", this.state.itineraryVehicles);
  
      const response = await get(`${BaseUrl}/api/itineraries/itinerary-daily-plan/?itinerary__id=${id}&size=50`, requestOptions);
      console.log("Raw API Response (Daily Plans):", response.results);
  
      // Map daily plans and transform multiple_vehicle IDs into objects
      const dailyPlan = response.results.map((plan) => ({
        ...plan,
        multiple_vehicle: plan.multiple_vehicle || [], // Ensure it's an array
      }));
      let selected_plan = null;
      if (this.state.selected_plan) {
        selected_plan = dailyPlan.find((plan) => plan.id === this.state.selected_plan.id) || null;
      }
  
      const { day } = this.state;
      this.setState({
        Payemnts: dailyPlan,
        day: day + dailyPlan.length - 1,
        selected_plan,
        addDataloading: false,
        model_AddData: false,
        editDataloading: false,
        model_EditData: false,
      }, () => {
        console.log("Updated Payemnts state:", this.state.Payemnts);
      });
    } catch (error) {
      console.error("Error loading daily plan data:", error);
      toastr.error("Failed to load daily plan data", "");
    }
  }

  async loadItineraryActivities() {
    let id = this.props.match.params.id;
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-activities/?itinerary__id=${id}`, requestOptions)
      .then((res) => res.json())
      .then(
        (data) => {
          let options = [];
          for (let i = 0; i < data.length; i++) {
            options.push({ label: data[i].activity.name, value: data[i].activity.id });
          }
          let Activities = [
            {
              label: "Activities",
              options: options,
            },
          ];
          this.setState({ itineraryActivities: data, Activities });
        },
        (error) => {
          console.log(error, "error--------------");
        }
      );
  }

  async loadItineraryHotels() {
    let id = this.props.match.params.id;
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-hotels/?itinerary__id=${id}`, requestOptions)
      .then((res) => res.json())
      .then(
        (data) => {
          let options = [{ label: "-------", value: "" }];
          for (let i = 0; i < data.length; i++) {
            options.push({ label: data[i].hotel.name, value: data[i].hotel.id });
          }
          let Hotels = [
            {
              label: "Hotels",
              options: options,
            },
          ];
          this.setState({ itineraryHotels: data, Hotels });
        },
        (error) => {
          console.log(error, "error--------------");
        }
      );
  }

  async loadItineraryVehicles() {
    let id = this.props.match.params.id;
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-vehicles/?itinerary__id=${id}`, requestOptions)
      .then((res) => res.json())
      .then(
        (data) => {
          let options = [{ label: "-------", value: "" }];
          for (let i = 0; i < data.length; i++) {
            options.push({ label: data[i].vehicle.name, value: data[i].vehicle.id });
          }
          let Vehicles = [
            {
              label: "Vehicles",
              options: options,
            },
          ];
          this.setState({ itineraryVehicles: data, Vehicles });
        },
        (error) => {
          console.log(error, "error--------------");
        }
      );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selected_id !== this.state.selected_id) {
      this.setState({ comment: this.state.selected_id.comment || "" });
    }
  }

  getNextDays(date, count) {
    let result = new Date(date);
    result.setDate(result.getDate() + count);
    return Moment(result).format("DD-MM-YYYY");
  }

  handleChange = (value) => {
    this.setState({ comment: value });
  };

  ondayChange(day) {
    const { itinerary } = this.state;
    let date_diff = getDifferenceInDays(new Date(itinerary.end_date), new Date(itinerary.start_date));
    if (date_diff + 1 < parseInt(day)) {
      toastr.error(`Itinerary is for ${date_diff + 1} Days`, "");
      this.setState({ date: false });
    } else {
      let data = `${this.getNextDays(itinerary.start_date, day - 1)}`;
      this.setState({ date: data });
    }
  }

  handleAddNewRowData(e, values) {
    let heading = document.getElementById("heading").value;
    const { itinerary, selectedCurrentLocations, selectedTravelLocation, selectedVisitingPlaces, date, selectedActivities, selectedHotels, selectedVehicles } = this.state;
    let date_diff = getDifferenceInDays(new Date(itinerary.end_date), new Date(itinerary.start_date));
    if (selectedCurrentLocations.value === "") {
      toastr.error("Please Select Current Location", "");
    } else if (date === false) {
      toastr.error(`Itinerary is for ${date_diff + 1} Days`, "Invalid Day");
    } else {
      let places_ids = selectedVisitingPlaces.map((place) => place.value);
      let activities = selectedActivities.map((activity) => activity.value);
      let hotels = selectedHotels.map((hotel) => hotel.value);
      let vehicleIds = selectedVehicles.map((vehicle) => vehicle.value).filter((v) => v !== "");
  
      let dailydata = {
        day: values.day,
        itinerary: itinerary.id,
        current_location: selectedCurrentLocations.value,
        to_travel: selectedTravelLocation.value,
        visiting_places: places_ids,
        multiple_vehicle: vehicleIds, // Array of IDs like [56, 78]
        hotels: hotels,
        activity: activities,
        comment: this.state.comment,
        heading: heading,
      };
  
      console.log("Payload being sent to API (POST):", dailydata);
  
      this.setState({ addDataloading: true });
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
        body: JSON.stringify(dailydata),
      };
      fetch(`${BaseUrl}/api/itineraries/itinerary-daily-plan/`, requestOptions)
        .then((res) => {
          if (res.status >= 400) {
            res.json().then((data) => {
              console.log("API Error (POST):", data);
              toastr.error("Something Went Wrong", "");
              this.setState({ addDataloading: false, model_AddData: false });
            });
          } else {
            res.json().then((data) => {
              console.log("API Response (POST):", data);
              this.loadDailyPlanData();
            });
          }
        })
        .catch((error) => {
          console.error("Fetch Error (POST):", error);
          toastr.error("Network Error", "");
          this.setState({ addDataloading: false, model_AddData: false });
        });
    }
  }
  
  handleEditRowSubmit = () => {
    const { itinerary, selectedCurrentLocations, selectedTravelLocation, selectedVisitingPlaces, selected_id, selectedActivities, selectedHotels, selectedVehicles } = this.state;
    let heading = document.getElementById("edit_heading").value;
    let places_ids = selectedVisitingPlaces.map((place) => place.value);
    let activities = selectedActivities.map((activity) => activity.value);
    let hotels = selectedHotels.map((hotel) => hotel.value);
    let vehicleIds = selectedVehicles.map((vehicle) => vehicle.value).filter((v) => v !== "");
  
    let dailydata = {
      itinerary: itinerary.id,
      current_location: selectedCurrentLocations.value,
      to_travel: selectedTravelLocation.value,
      visiting_places: places_ids,
      multiple_vehicle: vehicleIds, // Array of IDs like [56, 78]
      hotels: hotels,
      activity: activities,
      comment: this.state.comment,
      heading: heading,
    };
  
    console.log("Payload being sent to API (PUT):", dailydata);
  
    this.setState({ editDataloading: true });
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
      body: JSON.stringify(dailydata),
    };
    fetch(`${BaseUrl}/api/itineraries/itinerary-daily-plan/${selected_id.id}/`, requestOptions)
      .then((res) => {
        if (res.status >= 400) {
          res.json().then((data) => {
            console.log("API Error (PUT):", data);
            toastr.error("Something Went Wrong", "");
            this.setState({ editDataloading: false, model_EditData: false });
          });
        } else {
          res.json().then((data) => {
            console.log("API Response (PUT):", data);
            this.loadDailyPlanData();
          });
        }
      })
      .catch((error) => {
        console.error("Fetch Error (PUT):", error);
        toastr.error("Network Error", "");
        this.setState({ editDataloading: false, model_EditData: false });
      });
  };

  handleEditRowData(row) {
    let selectedCurrentLocations = { label: row.current_location.name, value: row.current_location.id };
    let selectedTravelLocation = {
      label: row.to_travel ? row.to_travel.name : "Select To Travel Location",
      value: row.to_travel ? row.to_travel.id : "",
    };
    let selectedVisitingPlaces = row.visiting_places.map((place) => ({ label: place.name, value: place.id }));
    let selectedHotels = row.hotels.map((hotel) => ({ label: hotel.name, value: hotel.id }));
    let selectedActivities = row.activity.map((activity) => ({ label: activity.name, value: activity.id }));
    let selectedVehicles = row.multiple_vehicle.map((v) => ({ label: v.name, value: v.id }));
  
    this.setState({
      model_EditData: true,
      selected_id: row,
      selectedCurrentLocations,
      selectedTravelLocation,
      selectedVisitingPlaces,
      selectedHotels,
      selectedVehicles,
      selectedActivities,
      comment: row.comment || "",
    });
  }

  handleDeletePlan = (id) => {
    const { day } = this.state;
    const requestOptions = {
      method: "DELETE",
      headers: { Authorization: `Bearer ${this.obj.access}` },
    };
    fetch(`${BaseUrl}/api/itineraries/itinerary-daily-plan/${id}/`, requestOptions).then((res) => {
      if (res.status >= 400) {
        console.log("error");
      } else {
        this.loadDailyPlanData();
        this.setState({
          hotel_id: "",
          success_confirm: true,
          alert_confirm: false,
          dynamic_title: "Deleted!",
          dynamic_description: "Row has been deleted.",
          day: day - 1,
        });
      }
    });
  };

  handleSaveTimePlan(e, values) {
    const { edit_selected_plan, itinerary, selected_plan } = this.state;
    let data = {};
    data["itinerary"] = itinerary.id;
    data["plan"] = document.getElementById("time_plan").value;
    data["time"] = values.time;
    if (edit_selected_plan) {
      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
        body: JSON.stringify(data),
      };
      fetch(`${BaseUrl}/api/itineraries/itinerary-time-plan/${edit_selected_plan.id}/`, requestOptions).then((res) => {
        if (res.status >= 400) {
          res.json().then((data) => {
            console.log(data, "-error");
            toastr.error("Something Went Wrong", "");
            this.setState({ addDataloading: false, modal_time_plan: false });
          });
        } else {
          this.loadDailyPlanData();
          this.tog_time_plan();
        }
      });
    } else {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
        body: JSON.stringify(data),
      };
      fetch(`${BaseUrl}/api/itineraries/itinerary-time-plan/`, requestOptions).then((res) => {
        if (res.status >= 400) {
          res.json().then((data) => {
            console.log(data, "-error");
            toastr.error("Something Went Wrong", "");
            this.setState({ addDataloading: false, modal_time_plan: false });
          });
        } else {
          this.tog_time_plan();
          res.json().then((data) => {
            let ids = [];
            for (let i = 0; i < selected_plan.time_plan.length; i++) {
              ids.push(selected_plan.time_plan[i].id);
            }
            ids.push(data.id);
            let dailydata = { time_plan: ids, itinerary: itinerary.id };
            const requestOptions = {
              method: "PUT",
              headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.obj.access}` },
              body: JSON.stringify(dailydata),
            };
            fetch(`${BaseUrl}/api/itineraries/itinerary-daily-plan/${selected_plan.id}/`, requestOptions).then((res) => {
              if (res.status >= 400) {
                res.json().then((data) => {
                  console.log(data, "-error");
                  toastr.error("Something Went Wrong", "");
                });
              } else {
                this.loadDailyPlanData();
                this.tog_time_plan_detail();
              }
            });
          });
        }
      });
    }
  }

  handleDeleteTimePlan = (id) => {
    const requestOptions = {
      method: "DELETE",
      headers: { Authorization: `Bearer ${this.obj.access}` },
    };
    fetch(`${BaseUrl}/api/itineraries/itinerary-time-plan/${id}/`, requestOptions).then((res) => {
      if (res.status >= 400) {
        console.log("error");
      } else {
        this.loadDailyPlanData();
      }
    });
  };

  handleSelectedCurrentLocations = (selectedCurrentLocations) => {
    this.setState({ selectedCurrentLocations });
  };

  handleSelectedTravellLocations = (selectedTravelLocation) => {
    this.setState({ selectedTravelLocation });
  };

  handleSelectedVisitingPlaces = (selectedVisitingPlaces) => {
    this.setState({ selectedVisitingPlaces });
  };

  handleSelectedActivities = (selectedActivities) => {
    this.setState({ selectedActivities });
  };

  handleSelectedHotels = (selectedHotels) => {
    this.setState({ selectedHotels });
  };

  handleSelectedVehicles = (selectedVehicles) => {
    this.setState({ selectedVehicles });
  };

  showVisitingPlaces(visitingPlaces) {
    let places = "";
    for (let i = 0; i < visitingPlaces.length; i++) {
      places = i === 0 ? places + visitingPlaces[i].name : places + ", " + visitingPlaces[i].name;
    }
    return places;
  }

  render() {
    const { Payemnts, itinerary, selected_plan } = this.state;
    let breadcrumbItems = [
      { title: "Itineraries", link: "/itineraries" },
      { title: itinerary?.name, link: `/itinerary-detail/${itinerary?.id}` },
      { title: "Itinerary Plan", link: "#" },
    ];

    const columns = [
      {
        dataField: "id",
        text: "ID",
        hidden: true,
      },
      {
        dataField: "day",
        text: "Day",
        headerStyle: { backgroundColor: "#f79934" },
      },
      {
        dataField: "date",
        isDummyField: true,
        text: "Date",
        headerStyle: { backgroundColor: "#f79934" },
        formatter: (cellContent, row) => `${this.getNextDays(itinerary.start_date, row.day - 1)}`,
      },
      {
        dataField: "current",
        text: "Current location",
        sort: true,
        headerStyle: { backgroundColor: "#f79934" },
        formatter: (cellContent, row) => row.current_location.name,
      },
      {
        dataField: "to_travel",
        text: "To Travel",
        sort: true,
        headerStyle: { backgroundColor: "#f79934" },
        formatter: (cellContent, row) => (row.to_travel ? row.to_travel.name : ""),
      },
      {
        dataField: "visiting_places",
        text: "Visiting Places",
        sort: true,
        headerStyle: { backgroundColor: "#f79934" },
        formatter: (cellContent, row) =>
          row.visiting_places.length === 0 ? (
            ""
          ) : this.showVisitingPlaces(row.visiting_places).length > 20 ? (
            <p>
              {this.showVisitingPlaces(row.visiting_places).substring(0, 20)}
              <Link
                to="#"
                onClick={() => {
                  this.setState({
                    heading: "Visiting Places",
                    desc: this.showVisitingPlaces(row.visiting_places),
                  });
                  this.tog_center();
                }}
                className="me-3 text-success"
              >
                {" "}
                <i className="fas fa-ellipsis-h"></i>
              </Link>
            </p>
          ) : (
            this.showVisitingPlaces(row.visiting_places)
          ),
      },
      {
        dataField: "hotels",
        text: "Hotel",
        sort: true,
        headerStyle: { backgroundColor: "#f79934" },
        formatter: (cellContent, row) =>
          row.hotels.length === 0 ? "-" : row.hotels[0].name.substring(0, 20),
        title: (cell, row) =>
          row.hotels.length === 0 ? "-" : row.hotels.map((hotel) => hotel.name + ", "),
      },
      {
        dataField: "multiple_vehicle",
        text: "Vehicles",
        sort: true,
        headerStyle: { backgroundColor: "#f79934" },
        formatter: (cellContent, row) =>
          row.multiple_vehicle && row.multiple_vehicle.length > 0
            ? row.multiple_vehicle.map((v) => v.name).join(", ").substring(0, 20)
            : "-",
        title: (cell, row) =>
          row.multiple_vehicle && row.multiple_vehicle.length > 0
            ? row.multiple_vehicle.map((v) => v.name).join(", ")
            : "-",
      },
      {
        dataField: "activity",
        text: "Activities",
        sort: true,
        headerStyle: { backgroundColor: "#f79934" },
        formatter: (cellContent, row) =>
          row.activity.length === 0 ? "-" : row.activity[0].name.substring(0, 20),
        title: (cell, row) =>
          row.activity.length === 0 ? "-" : row.activity.map((acti) => acti.name + ", "),
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        width: "10%",
        headerStyle: { backgroundColor: "#f79934" },
        formatter: (cellContent, row) => (
          <React.Fragment>
            <div style={{ textAlign: "center" }}>
              <Link
                to="#"
                onClick={() => {
                  this.setState({ selected_plan: row });
                  this.tog_time_plan_detail();
                }}
                className="me-4 text-success"
              >
                <i className="fas fa-eye font-size-14"></i>
              </Link>
              <Link to="#" onClick={() => this.handleEditRowData(row)} className="me-4 text-primary">
                <i className="fas fa-pen font-size-14"></i>
              </Link>
              <Link
                to="#"
                onClick={() => this.setState({ alert_confirm: true, plan_id: row.id })}
                className="me-2 text-danger"
              >
                <i className="far fa-trash-alt font-size-14"></i>
              </Link>
            </div>
          </React.Fragment>
        ),
      },
    ];

    const TimePlancolumns = [
      {
        dataField: "id",
        text: "ID",
        hidden: true,
      },
      {
        dataField: "time",
        text: "Time",
        headerStyle: { backgroundColor: "#f79934", width: "10%" },
        formatter: (cellContent) => Moment(new Date(`2022-10-01T${cellContent}`)).format("LT"),
      },
      {
        dataField: "plan",
        text: "Plan",
        headerStyle: { backgroundColor: "#f79934" },
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        width: "10%",
        headerStyle: { backgroundColor: "#f79934", width: "10%" },
        formatter: (cellContent, row) => (
          <React.Fragment>
            <div style={{ textAlign: "center" }}>
              <Link
                to="#"
                onClick={() => {
                  this.setState({ edit_selected_plan: row });
                  this.tog_time_plan();
                }}
                className="me-4 text-primary"
              >
                <i className="fas fa-pen font-size-14"></i>
              </Link>
              <Link to="#" onClick={() => this.handleDeleteTimePlan(row.id)} className="me-2 text-danger">
                <i className="far fa-trash-alt font-size-14"></i>
              </Link>
            </div>
          </React.Fragment>
        ),
      },
    ];

    const formats = [
      "font",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "color",
      "background",
      "script",
      "header",
      "blockquote",
      "code-block",
      "indent",
      "list",
      "direction",
      "align",
      "link",
      "image",
      "video",
      "formula",
    ];

    const modules = {
      toolbar: [
        [{ font: [] }, { size: [] }],
        [{ header: "1" }, { header: "2" }, { script: "sub" }, { script: "super" }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
        ["blockquote", "code-block"],
        [{ direction: "rtl" }, { align: [] }],
        ["link", "image", "video", "formula"],
        ["clean"],
      ],
    };
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="" breadcrumbItems={breadcrumbItems} />
            {!isEmpty(this.state.itinerary) ? (
              <>
                <Row>
                  <div className="timeline-block my-3">
                    <div className="time-show-btn mt-0">
                      {has_Permission(this.obj.user, 1, "edit") ? (
                        <Link to={`/itinerary-detail/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2">
                          <i className="fas fa-clipboard-list font-size-15"></i> Itinerary Detail
                        </Link>
                      ) : null}
                      
                      {has_Permission(this.obj.user, 7, "read") ? (
                        <Link to={`/itinerary-payment-detail/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2">
                          <i className="fas fa-rupee-sign font-size-15"></i> Payments
                        </Link>
                      ) : null}
                      {has_Permission(this.obj.user, 7, "read") ? (
                        <Link to={`/invoices/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2">
                          <i className="fas fa-file-invoice-dollar font-size-15"></i> Invoices
                        </Link>
                      ) : null}
                      {has_Permission(this.obj.user, 1, "edit") ? (
                        <Link
                          to={`/itinerary-terms-&-condition/${this.props.match.params.id}`}
                          className="btn btn-link btn-rounded w-lg me-2"
                        >
                          <i className="far fa-list-alt font-size-15"></i> Terms & Conditions
                        </Link>
                      ) : null}
                      
                      <Link
                        to={`/itinerary/${this.state.itinerary.id}/${createSlugfromName(this.state.itinerary.name)}`}
                        target="_blank"
                        className="btn btn-link btn-rounded w-lg"
                      >
                        <i className="far fa-eye font-size-15"></i> View Itinerary
                      </Link>
                    </div>
                  </div>
                </Row>

                <Row>
                  <Col xs={12}>
                    <Card>
                      <CardBody>
                        <h4 className="card-title">{itinerary?.title}</h4>

                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            data={Payemnts}
                            columns={columns}
                            defaultSorted={[
                              {
                                dataField: "day",
                                order: "asc",
                              },
                            ]}
                            hover
                            responsive
                            classes={"table align-middle table-nowrap"}
                            headerWrapperClasses={"table-light"}
                          />
                        </div>

                        <div className="mt-2" style={{ textAlign: "center" }}>
                          <Button color="secondary" outline className="waves-effect me-1 mb-3" onClick={this.tog_addData}>
                            Add New Detail
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <div className="d-flex align-items-center justify-content-center min-vh-100">
                <Spinner type="grow" className="me-2" color="secondary" />
                <Spinner type="grow" className="me-2" color="secondary" />
                <Spinner type="grow" className="me-2" color="secondary" />
                <Spinner type="grow" className="me-2" color="secondary" />
              </div>
            )}
          </Container>
        </div>

        <Col sm={6} md={4} xl={3} className="mt-4">
          <Modal isOpen={this.state.modal_time_plan} toggle={this.tog_time_plan} centered={true}>
            <ModalHeader toggle={() => this.setState({ modal_time_plan: false })}>Add/Edit Time Plan</ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleSaveTimePlan}>
                <Row>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="time">
                      Time
                    </Label>
                    <AvField
                      name="time"
                      placeholder="Time"
                      type="time"
                      value={this.state.edit_selected_plan ? this.state.edit_selected_plan.time : ""}
                      errorMessage="Time"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="time"
                    />
                  </div>
                </Row>
                <Row>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="time_plan">
                      Plan
                    </Label>
                    <Input
                      type="textarea"
                      id="time_plan"
                      rows="3"
                      placeholder="Plan"
                      defaultValue={this.state.edit_selected_plan ? this.state.edit_selected_plan.plan : ""}
                    />
                  </div>
                </Row>
                <FormGroup className="mb-0">
                  {this.state.editDataloading ? (
                    <Spinner className="me-2 mt-2" color="primary" />
                  ) : (
                    <div>
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                    </div>
                  )}
                </FormGroup>
              </AvForm>
            </ModalBody>
          </Modal>
        </Col>

        <Col sm={6} md={4} xl={3} className="mt-4">
          <Modal isOpen={this.state.modal_time_plan_detail} toggle={this.tog_time_plan_detail} centered={true}>
            <ModalHeader toggle={() => this.setState({ modal_time_plan_detail: false })}>Time Plan</ModalHeader>
            <ModalBody>
              <div className="table-responsive">
                <BootstrapTable
                  keyField="id"
                  data={selected_plan ? selected_plan.time_plan : []}
                  columns={TimePlancolumns}
                  defaultSorted={[
                    {
                      dataField: "day",
                      order: "asc",
                    },
                  ]}
                  hover
                  responsive
                  classes={"table align-middle table-nowrap"}
                  headerWrapperClasses={"table-light"}
                />
              </div>

              <div className="mt-2">
                <Button color="dark" className="me-1 mb-3" onClick={this.tog_time_plan}>
                  <i className="fas fa-plus font-size-14"></i>
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </Col>

        <Col sm={6} md={4} xl={3} className="mt-4">
          <Modal isOpen={this.state.modal_center} toggle={this.tog_center} centered={true}>
            <ModalHeader toggle={() => this.setState({ modal_center: false })}>{this.state.heading}</ModalHeader>
            <ModalBody>
              <p>{this.state.desc}</p>
            </ModalBody>
          </Modal>
        </Col>

        <Col sm={6} md={4} xl={3} className="mt-4">
          <Modal isOpen={this.state.model_AddData} toggle={this.tog_addData} centered={true}>
            <ModalHeader toggle={() => this.tog_addData()}>Add New Data</ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleAddNewRowData}>
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <AvField
                        name="day"
                        label="Day"
                        onChange={(e) => this.ondayChange(e.target.value)}
                        placeholder="Enter Only number"
                        type="number"
                        errorMessage="Enter Only Number"
                        validate={{
                          required: { value: true },
                          maxLength: {
                            value: 2,
                            errorMessage: "Numbers must be less than 3 digit",
                          },
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <AvField
                        name="day"
                        label="Date"
                        type="text"
                        value={this.state.date ? this.state.date : ""}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label">Current Location</Label>
                      <Select
                        value={this.state.selectedCurrentLocations}
                        onChange={this.handleSelectedCurrentLocations}
                        options={this.state.VisitingPlaces}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label">To Travel</Label>
                      <Select
                        value={this.state.selectedTravelLocation}
                        onChange={this.handleSelectedTravellLocations}
                        options={this.state.ToTravelLocations}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Visiting Places</Label>
                      <Select
                        value={this.state.selectedVisitingPlaces}
                        onChange={this.handleSelectedVisitingPlaces}
                        isMulti={true}
                        options={this.state.VisitingPlaces}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="price">
                        Heading
                      </Label>
                      <Input type="text" id="heading" rows="1" placeholder="Heading" style={{ width: "100%" }} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Hotel</Label>
                      <Select
                        value={this.state.selectedHotels}
                        onChange={this.handleSelectedHotels}
                        options={this.state.Hotels}
                        isMulti={true}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Vehicles</Label>
                      <Select
                        value={this.state.selectedVehicles}
                        onChange={this.handleSelectedVehicles}
                        options={this.state.Vehicles}
                        isMulti={true}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Activities</Label>
                      <Select
                        value={this.state.selectedActivities}
                        onChange={this.handleSelectedActivities}
                        isMulti={true}
                        options={this.state.Activities}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="price">
                      Comment
                    </Label>
                    <ReactQuill
                      id="textarea"
                      value={this.state.comment}
                      onChange={this.handleChange}
                      placeholder="Additional Comments"
                      formats={formats}
                      modules={modules}
                    />
                  </div>
                </Row>
                <FormGroup className="mb-0">
                  {this.state.addDataloading ? (
                    <Spinner className="me-2 mt-2" color="primary" />
                  ) : (
                    <div>
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                    </div>
                  )}
                </FormGroup>
              </AvForm>
            </ModalBody>
          </Modal>
        </Col>

        <Col sm={6} md={4} xl={3} className="mt-4">
          <Modal isOpen={this.state.model_EditData} toggle={this.tog_EditData} centered={true}>
            <ModalHeader toggle={() => this.tog_EditData()}>Edit Plan</ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleEditRowSubmit}>
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label">Current Location</Label>
                      <Select
                        value={this.state.selectedCurrentLocations}
                        onChange={this.handleSelectedCurrentLocations}
                        options={this.state.VisitingPlaces}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label">To Travel</Label>
                      <Select
                        value={this.state.selectedTravelLocation}
                        onChange={this.handleSelectedTravellLocations}
                        options={this.state.ToTravelLocations}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Visiting Places</Label>
                      <Select
                        value={this.state.selectedVisitingPlaces}
                        onChange={this.handleSelectedVisitingPlaces}
                        isMulti={true}
                        options={this.state.VisitingPlaces}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="price">
                      Heading
                    </Label>
                    <Input
                      type="text"
                      id="edit_heading"
                      rows="1"
                      placeholder="Heading"
                      defaultValue={this.state.selected_id.heading}
                    />
                  </div>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Hotel</Label>
                      <Select
                        value={this.state.selectedHotels}
                        onChange={this.handleSelectedHotels}
                        options={this.state.Hotels}
                        isMulti={true}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Vehicles</Label>
                      <Select
                        value={this.state.selectedVehicles}
                        onChange={this.handleSelectedVehicles}
                        options={this.state.Vehicles}
                        isMulti={true}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Activities</Label>
                      <Select
                        value={this.state.selectedActivities}
                        onChange={this.handleSelectedActivities}
                        isMulti={true}
                        options={this.state.Activities}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="price">
                      Comment
                    </Label>
                    <ReactQuill
                      id="edit_textarea"
                      value={this.state.comment}
                      onChange={this.handleChange}
                      placeholder="Additional Comments"
                      formats={formats}
                      modules={modules}
                    />
                  </div>
                </Row>
                <FormGroup className="mb-0">
                  {this.state.editDataloading ? (
                    <Spinner className="me-2 mt-2" color="primary" />
                  ) : (
                    <div>
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                    </div>
                  )}
                </FormGroup>
              </AvForm>
            </ModalBody>
          </Modal>
        </Col>

        {this.state.alert_confirm ? (
          <SweetAlert
            title="Are you sure?"
            warning
            showCancel
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={() => this.handleDeletePlan(this.state.plan_id)}
            onCancel={() =>
              this.setState({
                alert_confirm: false,
                plan_id: "",
              })
            }
          >
            You won't be able to revert this!
          </SweetAlert>
        ) : null}

        {this.state.success_confirm ? (
          <SweetAlert
            success
            title={this.state.dynamic_title}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={() => this.setState({ success_confirm: false, alert_confirm: false })}
          >
            {this.state.dynamic_description}
          </SweetAlert>
        ) : null}
      </React.Fragment>
    );
  }
}

export default DailyPlan;